import React from 'react';
import AdminLayout from '@app/layout/AdminLayout.tsx';
import { withAuthenticationRequired } from '@auth0/auth0-react';
import { RingilHeading } from '@components/styles.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import AdminEmailHistory from '@components/RingilComponents/emailHistory/AdminEmailHistory.tsx';

const IndexPage: React.FC = () => {
  const { tr } = useTranslationLgs();
  const title = tr('EmailHistory.pageTitle', 'Communication history');
  return (
    <AdminLayout title={title}>
      <RingilHeading>{title}</RingilHeading>
      <AdminEmailHistory />
    </AdminLayout>
  );
};

export default withAuthenticationRequired(IndexPage);
